<div class="reconciliation-tab search-filter-section">
  <h3 class="criteria-title cr-header-title">Cash Reconciliation</h3>
  <div class="filter-container cr-header-actions">
    <button type="button" class="cr-action-btn cr-action-btn--ghost" (click)="onFixPastData()">
      <span>Fix Past Data</span>
      <img src="assets/images/employee/database.svg" alt="Fix Past Data" />
    </button>
    <button type="button" class="cr-action-btn cr-action-btn--dark" (click)="onGenerateReport()">
      <span>Report</span>
      <img src="assets/images/employee/file-text.svg" alt="Report" />
    </button>
    <div class="cr-calendar-wrap">
      <button
        type="button"
        class="cr-calendar-btn"
        aria-label="Calendar"
        (click)="toggleCalendarPopover($event)"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <rect
            x="3"
            y="5"
            width="18"
            height="16"
            rx="3"
            stroke="currentColor"
            stroke-width="1.6"
          ></rect>
          <path d="M3 10.5H21" stroke="currentColor" stroke-width="1.6"></path>
          <path d="M8 3V7M16 3V7" stroke="currentColor" stroke-width="1.6"></path>
        </svg>
      </button>
      <div *ngIf="calendarPopoverOpen" class="cr-calendar-pop" (click)="$event.stopPropagation()">
        <app-wi-date-range-picker
          mode="date"
          [inline]="true"
          [showActions]="false"
          [selectedDate]="reconciliationViewDate"
          [disableDate]="disableFutureDates"
          (dateChange)="onReconciliationDateSelect($event)"
        >
        </app-wi-date-range-picker>
      </div>
    </div>
  </div>
</div>

<!-- Fix past data modal -->
<app-wi-data-modal
  *ngIf="fixPastModalOpen"
  [isOpen]="fixPastModalOpen"
  title="Fix Past Data"
  [width]="fixShowResultsView ? '1058px' : '570px'"
  [panelClass]="
    'cr-modal cr-modal--fix-past ' +
    (fixShowResultsView ? 'cr-modal--fix-past--results' : 'cr-modal--fix-past--form')
  "
  ariaLabel="Fix Past Data"
  (modalClose)="closeFixPastModal()"
  bodyClass="data-modal-no-bg-body"
>
  <div
    class="cr-fix-body pd-15 cr-overflow-auto"
    [class.cr-fix-body--expanded]="fixShowResultsView"
  >
    <!-- ERROR -->
    <div class="error-text" *ngIf="fixStartDate && fixEndDate && !isDateRangeValid">
      Please select a date range within 30 days
    </div>

    <!-- DATE -->
    <label class="cr-fix-label"> Select Date / Date Range </label>

    <div class="cr-date-picker-wrap">
      <app-wi-date-range-picker
        mode="fixed"
        [startDate]="fixStartDate"
        [endDate]="fixEndDate"
        [minDays]="1"
        [maxDays]="30"
        [disableDate]="disableFutureDates"
        [showInlineValidation]="false"
        (rangeChange)="onRangeChange($event)"
      >
      </app-wi-date-range-picker>
    </div>

    <!-- EMPLOYEE -->
    <label class="cr-fix-label"> Employees </label>

    <div class="cr-employee-wrap">
      <app-wi-multi-select
        [options]="employeeOptions"
        [selectedIds]="selectedEmployeeIds"
        placeholder="Select Employee"
        tagsTitle="Selected Employees"
        [multipleSelectionText]="'{{count}} Employees Selected'"
        singleFallbackText="1 Employee Selected"
        (selectedIdsChange)="onSelectedEmployeeIdsChange($event)"
      >
      </app-wi-multi-select>
    </div>

    <!-- ACTION -->
    <div class="cr-fix-actions cr-fix-actions--end">
      <button
        type="button"
        class="submit-btn"
        [disabled]="!isDateRangeValid || selectedEmployeeIds.length === 0 || fixSearchLoading"
        (click)="submitFixPastData()"
      >
        {{ fixSearchLoading ? 'Submitting...' : 'Submit' }}
      </button>
    </div>

    <!-- LOADING -->
    <div *ngIf="fixSearchLoading" class="cr-loading">Loading employee details...</div>

    <!-- EMPTY -->
    <div
      *ngIf="
        fixShowResultsView && fixHasSearched && !fixSearchLoading && displayedData.length === 0
      "
    >
      <app-empty-result
        image="/assets/images/empty_screen.png"
        title="No records available"
        description="No cash reconciliation data available for this date."
        [showAction]="false"
      >
      </app-empty-result>
    </div>

    <!-- GRID -->
    <app-reconciliation-grid
      *ngIf="fixShowResultsView && displayedData.length > 0"
      class="cr-fix-results"
      [rows]="displayedData"
      [savingEmployeeIds]="savingEmployeeIds"
      (saveRow)="onSaveFixEmployeeRow($event)"
      (cancelEmployee)="onCancelFixEmployee($event)"
      (dirtyChange)="rebuildChangedEntriesMap()"
    >
    </app-reconciliation-grid>
  </div>
</app-wi-data-modal>

<!-- Generate Reports — step 1 -->
<app-wi-data-modal
  *ngIf="reportTypeModalOpen"
  [isOpen]="reportTypeModalOpen"
  title="Generate Reports"
  width="480px"
  panelClass="cr-modal cr-modal--report cr-modal--report-type"
  ariaLabel="Generate Reports"
  (modalClose)="closeReportTypeModal()"
>
  <div class="cr-report-body">
    <p class="cr-report-choose">Choose report range</p>
    <div class="cr-report-radios">
      <label class="cr-report-radio">
        <input
          type="radio"
          name="reportRange"
          value="daily"
          [(ngModel)]="selectedReportType"
          (ngModelChange)="onReportRangeTypeChange()"
        />
        <span>Daily</span>
      </label>
      <label class="cr-report-radio">
        <input
          type="radio"
          name="reportRange"
          value="monthly"
          [(ngModel)]="selectedReportType"
          (ngModelChange)="onReportRangeTypeChange()"
        />
        <span>Monthly</span>
      </label>
      <label class="cr-report-radio">
        <input
          type="radio"
          name="reportRange"
          value="custom"
          [(ngModel)]="selectedReportType"
          (ngModelChange)="onReportRangeTypeChange()"
        />
        <span>Custom Range</span>
      </label>
    </div>
    <div class="cr-report-picker-slot">
      <!-- Daily -->
      <app-wi-date-range-picker
        *ngIf="selectedReportType === 'daily'"
        mode="date"
        [inline]="true"
        [showActions]="false"
        [disableDate]="disableFutureDates"
        [selectedDate]="reportDate"
        (dateChange)="onDateChange($event)"
      >
      </app-wi-date-range-picker>
      <!-- Monthly -->
      <app-wi-date-range-picker
        *ngIf="selectedReportType === 'monthly'"
        mode="monthly"
        [inline]="true"
        [showActions]="false"
        [disableDate]="disableFutureDates"
        [selectedMonth]="selectedMonth"
        [selectedYear]="selectedYear"
        (monthYearChange)="onMonthYearChange($event)"
      >
      </app-wi-date-range-picker>
      <!-- Custom Range -->
      <app-wi-date-range-picker
        *ngIf="selectedReportType === 'custom'"
        mode="fixed"
        [inline]="true"
        [showActions]="false"
        [disableDate]="disableFutureDates"
        [startDate]="fixStartDate"
        [endDate]="fixEndDate"
        (rangeChange)="onCustomRangeChanged($event)"
      >
      </app-wi-date-range-picker>
    </div>
    <div class="cr-report-actions">
      <button
        type="button"
        class="cr-report-btn cr-report-btn--secondary"
        (click)="cancelReportTypeModal()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="cr-report-btn cr-report-btn--primary"
        [disabled]="!canSubmitReportGenerate"
        (click)="onReportGenerateClick()"
      >
        {{ reportLoading ? '…' : 'Generate' }}
      </button>
    </div>
  </div>
</app-wi-data-modal>

<!-- Generate Reports — step 2: result -->
<app-wi-data-modal
  *ngIf="reportResultModalOpen"
  [isOpen]="reportResultModalOpen"
  title="Cash Reconciliation Report"
  dialogId="cr-report-result-modal"
  width="900px"
  panelClass="cr-modal cr-modal--rep-past cr-modal--report cr-modal--report-result"
  ariaLabel="Cash Reconciliation Report"
  (modalClose)="closeReportResultModal()"
>
  <div class="cr-modal__head" modal-header>
    <h4 class="cr-modal__title">Cash Reconciliation Report</h4>
    <div class="cr-rep-head__right">
      <button
        type="button"
        class="cr-modal__x"
        (click)="closeReportResultModal()"
        aria-label="Close"
      >
        ×
      </button>
    </div>
  </div>
  <div class="cr-rep-body">
    <div class="data-modal__body--header">
      <p class="cr-rep-meta">
        <span class="cr-rep-dot">•</span>
        <span><strong>Date range:</strong> {{ reportDateRangeLabel }}</span>
        <span class="cr-rep-dot">•</span>
        <span><strong>Location:</strong> {{ reportLocationLabel }}</span>
        <span class="cr-rep-dot">•</span>
        <span><strong>Generated:</strong> {{ formatReportGeneratedAt(reportGeneratedAt) }}</span>
      </p>
      <button type="button" class="cr-rep-pdf" (click)="downloadReportAsPdf()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M12 3v10m0 0l-4-4m4 4l4-4M5 19h14"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span>Download as PDF</span>
      </button>
    </div>

    <div class="cr-rep-table-wrap mr-15">
      <table class="cr-rep-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Attendant</th>
            <th>Status</th>
            <th>Shift</th>
            <th>Location</th>
            <th>Opening Balance</th>
            <th>Expected Closing</th>
            <th>Closing Balance</th>
            <th>Delta</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of reportData; trackBy: trackByReportRowId">
            <td>{{ r.date }}</td>
            <td>{{ r.attendant }}</td>
            <td>
              <ng-container *ngIf="!statusIsPlain(r); else doubleDash">
                <app-cash-reconciliation-status-badge
                  [status]="r.match_status"
                  [delta]="r.match_status === 'unmatched' ? r.delta : null"
                />
              </ng-container>

              <ng-template #doubleDash>
                <span class="dash">--</span>
              </ng-template>
            </td>
            <td>{{ getShiftLabel(r.shift) || '--' }}</td>
            <td>{{ r.location }}</td>
            <td class="cr-rep-num">
              {{ r.opening_balance === null ? '—' : formatReportCurrency(r.opening_balance) }}
            </td>
            <td class="cr-rep-num">
              {{ r.expected_closing === null ? '—' : formatReportCurrency(r.expected_closing) }}
            </td>
            <td class="cr-rep-num">
              {{ r.closing_balance === null ? '—' : formatReportCurrency(r.closing_balance) }}
            </td>
            <td class="cr-rep-num" [ngClass]="reportDeltaClass(r.delta)">
              {{ r.delta === null ? '—' : formatReportCurrency(r.delta) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="cr-rep-summary-wrap pd-15">
      <div class="cr-rep-summary">
        <div class="cr-rep-sum-card">
          <div class="cr-rep-sum-label">Total Entries</div>
          <div class="cr-rep-sum-value">{{ twoDigit(reportTotalEntries) }}</div>
        </div>
        <div class="cr-rep-sum-card cr-rep-sum-card--ok">
          <div class="cr-rep-sum-label">Total Matched</div>
          <div class="cr-rep-sum-value">{{ twoDigit(reportTotalMatched) }}</div>
        </div>
        <div class="cr-rep-sum-card cr-rep-sum-card--bad">
          <div class="cr-rep-sum-label">Total Not Matched</div>
          <div class="cr-rep-sum-value">{{ twoDigit(reportTotalNotMatched) }}</div>
        </div>
        <div
          class="cr-rep-sum-card"
          [ngClass]="{
            'cr-rep-sum-card--ok': reportSumDeltas === 0,
            'cr-rep-sum-card--bad': reportSumDeltas !== 0,
          }"
        >
          <div class="cr-rep-sum-label">Sum of Deltas</div>
          <div class="cr-rep-sum-value">{{ formatReportCurrency(reportSumDeltas) }}</div>
        </div>
      </div>
    </div>
  </div>
</app-wi-data-modal>

<!-- Generate Reports — step 3: monthly/custom result -->
<app-wi-data-modal
  *ngIf="reportDateRangeModalOpen"
  [isOpen]="reportDateRangeModalOpen"
  title="Cash Reconciliation Report"
  width="900px"
  panelClass="cr-modal cr-modal--report cr-modal--report-result"
  ariaLabel="Cash Reconciliation Report"
  (modalClose)="closeReportDateRangeModal()"
  bodyClass="data-modal-no-bg-body"
>
  <div class="cr-rep-body">
    <div class="data-modal__body--header">
      <p class="cr-rep-meta">
        <span class="cr-rep-dot">•</span>
        <span><strong>Date range:</strong> {{ reportDateRangeLabel }}</span>
        <span class="cr-rep-dot">•</span>
        <span><strong>Location:</strong> {{ reportLocationLabel }}</span>
        <span class="cr-rep-dot">•</span>
        <span><strong>Generated:</strong> {{ formatReportGeneratedAt(reportGeneratedAt) }}</span>
      </p>
      <button type="button" class="cr-rep-pdf" (click)="downloadReportAsPdf()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M12 3v10m0 0l-4-4m4 4l4-4M5 19h14"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span>Download as PDF</span>
      </button>
    </div>

    <div *ngIf="reportLoading" class="cr-loading">Loading…</div>

    <div *ngIf="!reportLoading && reportData.length === 0">
      <app-empty-result
        image="/assets/images/empty_screen.png"
        title="No records available"
        description="No cash reconciliation data available for this date."
        [showAction]="false"
      >
      </app-empty-result>
    </div>

    <div class="cr-rep-report-grid cr-overflow-auto">
      <app-reconciliation-grid
        *ngIf="!reportLoading && reportData.length > 0"
        class="cr-fix-results"
        [rows]="reportGridData"
        [readonly]="true"
        bodyClass="rg-grid-body pd-15"
      ></app-reconciliation-grid>
      <div class="cr-rep-summary-wrap pd-15">
        <div class="cr-rep-summary">
          <div class="cr-rep-sum-card">
            <div class="cr-rep-sum-label">Total Entries</div>
            <div class="cr-rep-sum-value">{{ twoDigit(reportTotalEntries) }}</div>
          </div>
          <div class="cr-rep-sum-card cr-rep-sum-card--ok">
            <div class="cr-rep-sum-label">Total Matched</div>
            <div class="cr-rep-sum-value">{{ twoDigit(reportTotalMatched) }}</div>
          </div>
          <div class="cr-rep-sum-card cr-rep-sum-card--bad">
            <div class="cr-rep-sum-label">Total Not Matched</div>
            <div class="cr-rep-sum-value">{{ twoDigit(reportTotalNotMatched) }}</div>
          </div>
          <div
            class="cr-rep-sum-card"
            [ngClass]="{
              'cr-rep-sum-card--ok': reportSumDeltas === 0,
              'cr-rep-sum-card--bad': reportSumDeltas !== 0,
            }"
          >
            <div class="cr-rep-sum-label">Sum of Deltas</div>
            <div class="cr-rep-sum-value">{{ formatReportCurrency(reportSumDeltas) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-wi-data-modal>

<div class="table-section cr-root">
  <div class="table-section-inner">
    <div class="cr-date-strip">
      <div class="date-nav date-nav--compact">
        <button
          type="button"
          class="date-nav-btn"
          (click)="goToPreviousDay()"
          aria-label="Previous day"
        >
          <svg
            class="date-nav-ic"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M15 18L9 12L15 6"
              stroke="currentColor"
              stroke-width="2.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </button>
        <span class="date-nav-label">{{ formatDisplayDate() }}</span>
        <button type="button" class="date-nav-btn" (click)="goToNextDay()" aria-label="Next day">
          <svg
            class="date-nav-ic"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M9 6L15 12L9 18"
              stroke="currentColor"
              stroke-width="2.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="loading" class="cr-loading">Loading…</div>

  <div *ngIf="!loading && data.length === 0">
    <app-empty-result
      image="/assets/images/empty_screen.png"
      title="No records available"
      description="No cash reconciliation data available for this date."
      [showAction]="false"
    >
    </app-empty-result>
  </div>

  <div
    #cashTableWrapper
    class="table-wrapper drag-table-wrapper"
    *ngIf="!loading && data.length > 0"
  >
    <div class="table-container cr-table-surface cr-cash-table">
      <div class="cr-grid cr-grid--head table-header" aria-hidden="true">
        <div class="cr-cell cell cell--left employee-column">Employee</div>
        <div class="cr-cell cell cell--left">Status</div>
        <div class="cr-cell cell cell--left">Shift</div>
        <div class="cr-cell cell cell--left">Location</div>
        <div class="cr-cell cell cell--h-end">Opening Balance</div>
        <div class="cr-cell cell cell--h-left">Add Extra Cash</div>
        <div class="cr-cell cell cell--h-end">Payment Received</div>
        <div class="cr-cell cell cell--h-end">Expected Closing</div>
        <div class="cr-cell cell cell--h-end">Closing Balance</div>
        <div class="cr-cell cell">Delta</div>
        <div class="cr-cell cell cell--h-center">View Report</div>
      </div>

      <div
        *ngFor="let row of rows; trackBy: trackById"
        class="cr-grid cr-grid--row table-row"
        [class.cr-grid--grayed]="row.is_grayed"
        [class.employee-row]="true"
      >
        <!-- Employee -->
        <div class="cr-cell cell cr-cell--employee cell--left employee-column">
          <ng-container *ngIf="!row.is_grayed; else dEmployee">
            <div class="employee-info">
              <div class="employee-avatar">
                <img
                  *ngIf="row.employee.avatar_url; else ini"
                  class="avatar-image"
                  [src]="row.employee.avatar_url"
                  [alt]="row.employee.name"
                />
                <ng-template #ini>
                  <span class="avatar-initials">{{ getEmployeeInitials(row.employee.name) }}</span>
                </ng-template>
              </div>
              <div class="employee-details">
                <div class="employee-name">{{ row.employee.name }}</div>
                <div class="employee-id">{{ row.employee.employee_code }}</div>
              </div>
            </div>
          </ng-container>
          <ng-template #dEmployee>
            <div class="employee-info cr-muted">
              <div class="employee-avatar">
                <span class="avatar-initials">{{ getEmployeeInitials(row.employee.name) }}</span>
              </div>
              <div class="employee-details">
                <div class="employee-name">{{ row.employee.name }}</div>
                <div class="employee-id">{{ row.employee.employee_code }}</div>
              </div>
            </div>
          </ng-template>
        </div>

        <div class="cr-cell cell cell--center">
          <ng-container *ngIf="!row.is_grayed; else d1">
            <app-custom-dropdown
              class="custom-dropdown custom-dropdown--status"
              variant="status"
              [controlled]="true"
              [class.dropdown-open]="isDropdownOpen(row, 'status')"
              [isOpen]="isDropdownOpen(row, 'status')"
              (isOpenChange)="onDropdownOpenChange($event, row, 'status')"
              [options]="statusDropdownOptions"
              [value]="row.status"
              [disabled]="row.is_grayed"
              [triggerStyle]="getStatusTriggerStyle(row.status)"
              (valueChange)="onStatusChange(row, $event)"
            />
          </ng-container>
          <ng-template #d1><span class="dash">--</span></ng-template>
        </div>

        <div class="cr-cell cell cell--center">
          <ng-container *ngIf="!row.is_grayed; else d2">
            <app-custom-dropdown
              class="custom-dropdown custom-dropdown--field"
              variant="plain"
              [controlled]="true"
              [isOpen]="isDropdownOpen(row, 'shift')"
              (isOpenChange)="onDropdownOpenChange($event, row, 'shift')"
              [options]="shiftDropdownOptions"
              [value]="getShiftValue(row)"
              [disabled]="row.is_grayed"
              (valueChange)="onShiftChange(row, $event)"
            />
          </ng-container>
          <ng-template #d2><span class="dash">--</span></ng-template>
        </div>

        <div class="cr-cell cell cell--center">
          <ng-container *ngIf="!row.is_grayed && row.location; else dLoc">
            <app-custom-dropdown
              class="custom-dropdown custom-dropdown--field"
              variant="plain"
              [controlled]="true"
              [isOpen]="isDropdownOpen(row, 'location')"
              (isOpenChange)="onDropdownOpenChange($event, row, 'location')"
              [options]="locationSelectOptions"
              [value]="row.location?.id ?? ''"
              [disabled]="row.is_grayed"
              (valueChange)="onLocationChange(row, $event)"
            />
          </ng-container>
          <ng-template #dLoc><span class="dash">--</span></ng-template>
        </div>

        <div class="cr-cell cell cell--end">
          <ng-container *ngIf="!row.is_grayed; else d3">
            <app-currency-action-input
              [value]="draft(row).opening"
              [useNumberInput]="true"
              [inputDisabled]="row.is_grayed"
              [actionDisabled]="!canSendOpening(row) || savingOpeningIds.includes(row.id)"
              [buttonText]="
                getOpeningButtonLabel(
                  row.opening_balance,
                  draft(row).opening,
                  draft(row).opening_status
                )
              "
              (valueChange)="onOpeningValueChange(row, $event)"
              (action)="sendOpening(row)"
              [minInput]="'1'"
            />
          </ng-container>
          <ng-template #d3><span class="dash">--</span></ng-template>
        </div>

        <div
          class="cr-cell cell cell--left cr-add-cash"
          [class.cr-add-cash--open]="addCashFor?.id === row.id"
        >
          <ng-container *ngIf="!row.is_grayed; else d4">
            <div class="add-cash-line">
              <button
                type="button"
                #addCashTrigger
                class="add-cash-btn"
                (click)="toggleAddCash(row, $event, addCashTrigger)"
                [class.add-cash-btn--active]="addCashFor?.id === row.id"
              >
                Add Cash
              </button>
              <div class="extra-total" *ngIf="row.extra_cash_total > 0">
                Total: ${{ formatCurrency(row.extra_cash_total) }}
              </div>
            </div>
            <div
              *ngIf="addCashFor?.id === row.id"
              #addCashPopup
              class="cr-add-pop"
              (click)="$event.stopPropagation()"
            >
              <h4 class="cr-add-pop__title">Add extra cash</h4>
              <app-currency-action-input
                class="cr-add-pop__input-wrap"
                [value]="addCashDraft"
                [useNumberInput]="true"
                [buttonText]="'Add'"
                [actionDisabled]="!addCashDraft || addCashDraft <= 0"
                [inputDisabled]="false"
                [allowDecimal]="false"
                [currencyPrefix]="'$'"
                (valueChange)="onAddCashValueChange($event)"
                (action)="confirmAddCash()"
                [minInput]="'1'"
              />
              <div class="cr-add-pop__divider" *ngIf="extraHistoryList(row.id).length > 0"></div>
              <ul class="cr-add-pop__history" *ngIf="extraHistoryList(row.id).length > 0">
                <li *ngFor="let h of extraHistoryList(row.id)">
                  <span class="t">{{ h.time }}</span>
                  <span class="a">${{ formatCurrency(h.amount) }}</span>
                </li>
              </ul>
            </div>
          </ng-container>
          <ng-template #d4><span class="dash">--</span></ng-template>
        </div>

        <div class="cr-cell cell cell--end">
          <ng-container *ngIf="!row.is_grayed; else d5">
            <div class="payment-received-cell">
              <span class="amount">${{ formatCurrency(row.payment_received) }}</span>
              <button
                type="button"
                class="view-details-link"
                [title]="paymentTooltip"
                (click)="onViewPaymentDetails(row)"
              >
                View Details
              </button>
            </div>
          </ng-container>
          <ng-template #d5><span class="dash">--</span></ng-template>
        </div>

        <div class="cr-cell cell cell--end">
          <ng-container *ngIf="!row.is_grayed; else d6">
            <span class="plain-amount">${{ formatCurrency(row.expected_closing) }}</span>
          </ng-container>
          <ng-template #d6><span class="dash">--</span></ng-template>
        </div>

        <div class="cr-cell cell cell--end">
          <ng-container *ngIf="!row.is_grayed; else d7">
            <app-currency-action-input
              [value]="draft(row).closing"
              [allowNull]="true"
              [useNumberInput]="true"
              [inputDisabled]="row.is_grayed"
              [actionDisabled]="!canSubmitClosing(row) || savingClosingIds.includes(row.id)"
              [buttonText]="'Submit'"
              (valueChange)="onClosingValueChange(row, $event)"
              (action)="submitClosing(row)"
              [minInput]="'1'"
            />
          </ng-container>
          <ng-template #d7><span class="dash">--</span></ng-template>
        </div>

        <div class="cr-cell cell cell--center cr-cell--delta">
          <ng-container *ngIf="!row.is_grayed; else d8">
            <ng-container *ngIf="row.match_status !== '--'; else plainDash">
              <div class="delta-stack">
                <app-cash-reconciliation-status-badge
                  [status]="row.match_status"
                  [delta]="row.match_status === 'unmatched' ? row.delta : null"
                />
                <span
                  *ngIf="row.mismatch_reason"
                  class="info-icon"
                  [matTooltip]="row.mismatch_reason"
                  matTooltipPosition="above"
                  tooltipEvent="hover"
                  appendTo="body"
                >
                  <img src="assets/images/employee/info.svg" alt="Info" class="icon-danger-dark" />
                </span>
              </div>
            </ng-container>
          </ng-container>
          <ng-template #plainDash>
            <span class="dash">--</span>
          </ng-template>
          <ng-template #d8>
            <span class="dash">--</span>
          </ng-template>
        </div>

        <div class="cr-cell cell cell--center cr-cell--view">
          <ng-container *ngIf="!row.is_grayed; else d9">
            <button
              type="button"
              class="view-report-btn btn"
              (click)="onViewReport(row)"
              [attr.aria-label]="'View report for ' + row.employee.name"
              [disabled]="!row.closing_balance || row.closing_balance <= 0"
            >
              <svg
                class="view-report-icon"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linejoin="round"
                />
                <path
                  d="M14 2v6h6M8 13h8M8 17h5"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
              </svg>
            </button>
          </ng-container>
          <ng-template #d9><span class="dash">--</span></ng-template>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="pagination-wrapper" *ngIf="data.length > 0 && totalItems > 0">
  <app-pagination-bar
    [paginationData]="paginationData"
    (pageChange)="onCrPageChange($event)"
    (itemsPerPageChange)="onCrItemsPerPageChange($event)"
  >
  </app-pagination-bar>
</div>

<!-- Payment Received -->
<app-wi-data-modal
  [isOpen]="paymentModalOpen"
  [title]="paymentModalOpen ? 'Cash Transactions — ' + paymentModal?.employee?.name : ''"
  width="700px"
  panelClass="cr-modal cr-modal--wide"
  [ariaLabel]="
    paymentModal ? 'Cash transactions for ' + paymentModal?.employee?.name : 'Cash transactions'
  "
  (modalClose)="closePaymentModal()"
>
  <p class="cr-modal__sub" modal-subtitle *ngIf="paymentModal as pm">
    {{ getFormattedDate() }} ·
    <span
      *ngIf="getShiftLabel(pm.shift) && getShiftLabel(pm.shift) !== '--'"
      class="cr-modal__shift"
    >
      {{ getShiftLabel(pm.shift) }}
    </span>
  </p>
  <ng-container *ngIf="paymentModal as pm">
    <div *ngIf="paymentTxLoading" class="cr-loading">Loading...</div>
    <div *ngIf="!paymentTxLoading && paymentTx.length === 0">
      <app-empty-result
        image="/assets/images/empty_screen.png"
        title="No records available"
        description="No cash reconciliation data available for this date."
        [showAction]="false"
      >
      </app-empty-result>
    </div>

    <div *ngIf="!paymentTxLoading && paymentTx.length !== 0" class="cr-tx-box mr-15">
      <div class="cr-tx-header">
        <span>Time</span>
        <span>Order ID</span>
        <span>Wash Type</span>
        <span class="r">Payment Received</span>
      </div>
      <div class="cr-tx-body">
        <div class="cr-tx-body-inner cr-overflow-auto">
          <div *ngFor="let t of paymentTx" class="cr-tx-row">
            <span>{{ t.time }}</span>
            <span>{{ t.orderId ? t.orderId : '--' }}</span>
            <span>{{ t.washType || '—' }}</span>
            <span class="r amt"
              >${{ formatCurrency(t.amount) }}
              <span *ngIf="t.kind === 'opening'" class="tx-pill">Opening balance</span>
              <span *ngIf="t.kind === 'order'" class="tx-pill">Order added cash</span>
              <span *ngIf="t.kind === 'extra'" class="tx-pill">Extra added cash</span>
              <span *ngIf="t.kind === 'closing'" class="tx-pill">Closing balance</span>
            </span>
          </div>
        </div>
        <!--<div class="cr-tx-total" *ngIf="!paymentTxLoading && paymentTx.length">
          <span>Total</span>
          <span>${{ formatCurrency(paymentTotal()) }}</span>
        </div>-->
      </div>
    </div>
  </ng-container>
</app-wi-data-modal>
